import { Component } from '@angular/core';

@Component({
  selector: 'app-guidelines',
  templateUrl: './guidelines.component.html',
  styleUrls: ['./guidelines.component.less']
})
export class GuidelinesComponent {
  breadcrumb: any = [
    {
      name: "Help",
      link: "/help"
    },
    {
      name: "Guidelines and Scores",
      link: null
    },
  ]
}
